import React from 'react';

import './styles.css';

const Title = ({label}) => (
    <h2 className="header-title"> {label} </h2>
);

export default Title;